import {createApp} from 'vue'
import App from './App.vue'

import '@/assets/main.css'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';
import './registerServiceWorker'

createApp(App)
    .use(store)
    .use(router)
    .use(VueSweetalert2)
    .mount('#app')
